<template>
  <div id="user-edit-tab-info">
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-col w-full mb-base">
          <template>
            <vs-table
              stripe
              max-items="4"
              pagination
              search
              :data="sortedLoans"
            >
              <template slot="thead">
                <vs-th @click.native="sort('type')">Category</vs-th>
                <vs-th @click.native="sort('loanName')"
                  >Loan Sub-Category</vs-th
                >
                <vs-th @click.native="sort('referenceNo')">Reference No</vs-th>
                <vs-th @click.native="sort('loanDate')">Loan Date</vs-th>
                <vs-th @click.native="sort('principalAmount')"
                  >Principal Amount</vs-th
                >
                <vs-th @click.native="sort('interestRate')"
                  >Interest Rate</vs-th
                >
                <vs-th @click.native="sort('withInterest')"
                  >With Interest</vs-th
                >
                <vs-th @click.native="sort('amortization')">Amortization</vs-th>
                <vs-th @click.native="sort('beginningBalance')">Balance</vs-th>
                <vs-th @click.native="sort('period')">Period</vs-th>
                <vs-th @click.native="sort('loanStatus')">Loan Status</vs-th>
                <vs-th @click.native="sort('hold')">Hold?</vs-th>
                <vs-th @click.native="sort('active')">Active?</vs-th>
                <vs-th @click.native="sort('effectivityDate')"
                  >Effectivity Date</vs-th
                >
                <vs-th @click.native="sort('expiryDate')">Expiry Date</vs-th>
                <vs-th @click.native="sort('resumeDate')">Resume Date</vs-th>
                <vs-th>Action</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].loanCategoryId">
                    {{
                      loanCategoryName(data[indextr].loanCategoryId)
                        .loanCategoryName
                    }}
                  </vs-td>
                  <vs-td :data="data[indextr].loanSubCategoryId">
                    {{
                      loanSubCategoryName(data[indextr].loanSubCategoryId)
                        .loanSubCategoryName
                    }}
                  </vs-td>
                  <vs-td :data="data[indextr].referenceNumber">
                    {{ data[indextr].referenceNumber }}
                  </vs-td>
                  <vs-td :data="data[indextr].loanDate">
                    {{ data[indextr].loanDate | fulldate }}
                  </vs-td>

                  <vs-td :data="data[indextr].principalAmount">
                    {{ data[indextr].principalAmount }}
                  </vs-td>
                  <vs-td :data="data[indextr].interestRate">
                    {{ data[indextr].interestRate }}
                  </vs-td>
                  <vs-td :data="data[indextr].withInterest">
                    {{ data[indextr].withInterest }}
                  </vs-td>
                  <vs-td :data="data[indextr].amortizationAmount">
                    {{ data[indextr].amortizationAmount }}
                  </vs-td>
                  <vs-td :data="data[indextr].amortizationAmount">
                    {{ data[indextr].beginningBalance }}
                  </vs-td>
                  <vs-td :data="data[indextr].periodId">
                    {{ periodName(data[indextr].periodId).periodName }}
                  </vs-td>
                  <vs-td :data="data[indextr].loanStatus">
                    {{ loanStatusName(data[indextr].loanStatus).status }}
                  </vs-td>
                  <vs-td :data="data[indextr].isHold">
                    <vs-checkbox
                      v-model="data[indextr].isHold"
                      class="pointer-events-none"
                    />
                  </vs-td>
                  <vs-td :data="data[indextr].isActive">
                    <vs-checkbox
                      v-model="data[indextr].isActive"
                      class="pointer-events-none"
                    />
                  </vs-td>
                  <vs-td :data="data[indextr].effectivityDate">
                    {{ data[indextr].effectivityDate | fulldate }}
                  </vs-td>
                  <vs-td :data="data[indextr].expirationDate">
                    {{ data[indextr].expirationDate | fulldate }}
                  </vs-td>
                  <vs-td :data="data[indextr].resumeDate">
                    {{ data[indextr].resumeDate | fulldate }}
                  </vs-td>
                  <vs-td>
                    <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                      <vx-tooltip text="Edit"
                        ><feather-icon
                          icon="Edit3Icon"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="editRecord(data[indextr].id)"
                      /></vx-tooltip>
                      <feather-icon
                        v-show="
                          getDateDiff(data[indextr].createdOn) <= 10
                            ? true
                            : false
                        "
                        icon="Trash2Icon"
                        svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                        @click="confirmDeleteRecord(data[indextr].id)"
                      />
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </template>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button
          type="gradient"
          color="primary"
          @click="promptAddNewLoans()"
          icon-pack="feather"
          icon="icon-plus"
          >Add</vs-button
        >
      </div>
    </div>

    <!-- ADD LOANS -->
    <vs-prompt
      class="email-compose"
      title="Add Loans"
      accept-text="Submit"
      @accept="onAddRecord"
      :is-valid="validForm"
      :active.sync="activePromptAddRecord"
    >
      <vx-card title="Please fill-out the following information">
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
            <span class="text-sm">Loan Type</span>
            <span style="color: red">*</span>
            <v-select
              name="loans category"
              v-validate="'required'"
              class="w-full"
              v-model="loanCategory"
              label="loanCategoryName"
              :options="getAllLoanCategory"
              placeholder="Please Select"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('loans category')"
              >{{ errors.first("loans category") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
            <span class="text-sm">Loan Name</span>
            <span style="color: red">*</span>
            <v-select
              name="loans sub-category"
              v-validate="'required'"
              class="w-full"
              v-model="loanSubCategory"
              label="loanSubCategoryName"
              :options="getAllLoanSubCategory"
              placeholder="Please Select"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('loans sub-category')"
              >{{ errors.first("loans sub-category") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
            <span class="text-sm">Reference Number</span>
            <vs-input
              class="w-full"
              placeholder="Reference Number"
              v-model="referenceNumber"
            />
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full mb-4">
            <span class="text-sm">Loan Date</span
            ><span style="color: red">*</span>
            <flat-pickr
              :config="configdateTimePicker"
              class="w-full"
              placeholder="Select Date"
              v-model="loanDate"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-4">
            <span class="text-sm">Principal Amount</span
            ><span style="color: red">*</span>
            <vs-input
              name="principal amount"
              v-validate="'max_value:10000000'"
              class="w-full"
              v-model="principalAmount"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('principal amount')"
              >{{ errors.first("principal amount") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full mb-4">
            <span class="text-sm">Period</span><span style="color: red">*</span>
            <v-select
              name="period"
              v-validate="'required'"
              class="w-full"
              v-model="period"
              label="periodName"
              :options="getAllPeriodByPaymentMode"
              placeholder="Please Select"
            />
            <span class="text-danger text-sm" v-show="errors.has('period')">{{
              errors.first("period")
            }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-4">
            <span class="text-sm">No of Terms</span
            ><span style="color: red">*</span>
            <vs-input
              name="loan terms"
              v-validate="'numeric'"
              class="w-full"
              v-model="noOfTerms"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('loan terms')"
              >{{ errors.first("loan terms") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full mb-4">
            <span class="text-sm">Interest Rate (%)</span>
            <vs-input
              name="interest rate"
              v-validate="'min_value:.01'"
              class="w-full"
              v-model="interestRate"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('interest rate')"
              >{{ errors.first("interest rate") }}</span
            >
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-4">
            <span class="text-sm">With Interest Amount</span
            ><span style="color: red">*</span>
            <vs-input
              name="with interest"
              v-validate="'min_value:.01'"
              class="w-full"
              v-model="withInterest"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('with interest')"
              >{{ errors.first("with interest") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full mb-4">
            <span class="text-sm">Amortization Amount</span
            ><span style="color: red">*</span>
            <vs-input
              name="amortization amount"
              v-validate="'min_value:.01'"
              class="w-full"
              v-model="amortizationAmount"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('amortization amount')"
              >{{ errors.first("amortization amount") }}</span
            >
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-4">
            <span class="text-sm">Balance</span>
            <vs-input
              name="beginning balance"
              class="w-full"
              v-model="beginningBalance"
            />
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/3 w-full mb-4">
            <span class="text-sm">Effectivity Date</span>
            <flat-pickr
              :config="configdateTimePicker"
              class="w-full"
              placeholder="Select Date"
              v-model="effectivityDate"
            />
          </div>
          <div class="vx-col sm:w-1/3 vw-full mb-4">
            <span class="text-sm">Expiry Date</span>
            <flat-pickr
              :config="configdateTimePicker"
              class="w-full"
              placeholder="Select Date"
              v-model="expirationDate"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-4">
            <span class="text-sm">Date Resume :</span>
            <flat-pickr
              :config="configdateTimePicker"
              class="w-full"
              placeholder="Select Date"
              v-model="resumeDate"
            />
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/3 w-full mb-4">
            <div class="flex">
              <vs-checkbox v-model="isHold">Hold?</vs-checkbox>
            </div>
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-4">
            <div class="flex">
              <vs-checkbox v-model="isActive">Active?</vs-checkbox>
            </div>
          </div>
        </div>
      </vx-card>
    </vs-prompt>
    <!-- END ADD EARNINGS -->
    <!-- EDIT EARNINGS -->
    <vs-prompt
      class="email-compose"
      title="Edit Loans"
      accept-text="Submit"
      @accept="onUpdateRecord"
      :is-valid="validForm"
      :active.sync="activePromptEditRecord"
    >
      <vx-card title="You may update the following information">
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
            <span class="text-sm">Loan Type</span>
            <span style="color: red">*</span>
            <v-select
              name="loans category"
              v-validate="'required'"
              class="w-full"
              v-model="loanCategory"
              label="loanCategoryName"
              :options="getAllLoanCategory"
              placeholder="Please Select"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('loans category')"
              >{{ errors.first("loans category") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
            <span class="text-sm">Loan Name</span>
            <span style="color: red">*</span>
            <v-select
              name="loans sub-category"
              v-validate="'required'"
              class="w-full"
              v-model="loanSubCategory"
              label="loanSubCategoryName"
              :options="getAllLoanSubCategory"
              placeholder="Please Select"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('loans sub-category')"
              >{{ errors.first("loans sub-category") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
            <span class="text-sm">Reference Number</span>
            <vs-input
              class="w-full"
              placeholder="Reference Number"
              v-model="referenceNumber"
            />
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full mb-4">
            <span class="text-sm">Loan Date</span
            ><span style="color: red">*</span>
            <flat-pickr
              :config="configdateTimePicker"
              class="w-full"
              placeholder="Select Date"
              v-model="loanDate"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-4">
            <span class="text-sm">Principal Amount</span
            ><span style="color: red">*</span>
            <vs-input
              name="principal amount"
              v-validate="'max_value:10000000'"
              class="w-full"
              v-model="principalAmount"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('principal amount')"
              >{{ errors.first("principal amount") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full mb-4">
            <span class="text-sm">Period</span><span style="color: red">*</span>
            <v-select
              name="period"
              v-validate="'required'"
              class="w-full"
              v-model="period"
              label="periodName"
              :options="getAllPeriodByPaymentMode"
              placeholder="Please Select"
            />
            <span class="text-danger text-sm" v-show="errors.has('period')">{{
              errors.first("period")
            }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-4">
            <span class="text-sm">No of Terms</span
            ><span style="color: red">*</span>
            <vs-input
              name="loan terms"
              v-validate="'numeric'"
              class="w-full"
              v-model="noOfTerms"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('loan terms')"
              >{{ errors.first("loan terms") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full mb-4">
            <span class="text-sm">Interest Rate (%)</span>
            <vs-input
              name="interest rate"
              v-validate="'min_value:.01'"
              class="w-full"
              v-model="interestRate"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('interest rate')"
              >{{ errors.first("interest rate") }}</span
            >
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-4">
            <span class="text-sm">With Interest Amount</span
            ><span style="color: red">*</span>
            <vs-input
              name="with interest"
              v-validate="'min_value:.01'"
              class="w-full"
              v-model="withInterest"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('with interest')"
              >{{ errors.first("with interest") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full mb-4">
            <span class="text-sm">Amortization Amount</span
            ><span style="color: red">*</span>
            <vs-input
              name="amortization amount"
              v-validate="'min_value:.01'"
              class="w-full"
              v-model="amortizationAmount"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('amortization amount')"
              >{{ errors.first("amortization amount") }}</span
            >
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-4">
            <span class="text-sm">Balance</span>
            <vs-input
              name="beginning balance"
              class="w-full"
              v-model="beginningBalance"
            />
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/3 w-full mb-4">
            <span class="text-sm">Effectivity Date</span>
            <flat-pickr
              :config="configdateTimePicker"
              class="w-full"
              placeholder="Select Date"
              v-model="effectivityDate"
            />
          </div>
          <div class="vx-col sm:w-1/3 vw-full mb-4">
            <span class="text-sm">Expiry Date</span>
            <flat-pickr
              :config="configdateTimePicker"
              class="w-full"
              placeholder="Select Date"
              v-model="expirationDate"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-4">
            <span class="text-sm">Date Resume :</span>
            <flat-pickr
              :config="configdateTimePicker"
              class="w-full"
              placeholder="Select Date"
              v-model="resumeDate"
            />
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/3 w-full mb-4">
            <div class="flex">
              <vs-checkbox v-model="isHold">Hold?</vs-checkbox>
            </div>
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-4">
            <div class="flex">
              <vs-checkbox v-model="isActive">Active?</vs-checkbox>
            </div>
          </div>
        </div>
      </vx-card>
    </vs-prompt>
    <!-- END EDIT EARNINGS -->
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { en, he } from "vuejs-datepicker/src/locale";

import moment from "moment";
import vSelect from "vue-select";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  props: {
    paymentMode: {
      type: Number,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selected: [],

      loansId: 0,
      loanCategory: [],
      loanSubCategory: [],
      referenceNumber: "",
      loanDate: new Date(),
      principalAmount: 0,
      termsType: [],
      noOfTerms: 1,
      interestRate: 0,
      withInterest: 0,
      amortizationAmount: 0,
      beginningBalance: 0,
      period: [],
      loanStatus: [],
      isHold: false,
      isActive: true,
      effectivityDate: null,
      expirationDate: null,
      resumeDate: null,
      activePromptAddRecord: false,
      activePromptEditRecord: false,

      configdateTimePicker: {
        allowInput: true,
      },
      currentDate: moment().utc().format("YYYY-MM-DD"),
      sortKey: "",
      sortOrder: 1, // 1 for ascending, -1 for descending
    };
  },
  created() {
    this.$store.dispatch("lookup/getAllLoanCategory").catch((err) => {
      console.log(err);
    });
    this.$store.dispatch("lookup/getAllLoanSubCategory").catch((err) => {
      console.log(err);
    });
    this.$store.dispatch("hrms/getAllSalaryInformation", this.userId);
    this.$store
      .dispatch("payroll/getAllLoans")
      .then(() => {})
      .catch((err) => {
        console.log(err);
      });
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    flatPickr,
  },
  computed: {
    getAllLoans() {
      return this.$store.getters["payroll/getLoansByUserId"](this.userId);
    },
    getAllLoanCategory() {
      return this.$store.state.lookup.loanCategory;
    },
    getAllLoanSubCategory() {
      return this.$store.getters["lookup/loanSubCategoryByCategory"](
        this.loanCategory.loanCategoryId
      );
    },
    getAllPeriodByPaymentMode() {
      return this.$store.getters["lookup/periodLookupByPaymentMode"](
        this.paymentMode
      );
    },
    getAllLoanStatus() {
      return this.$store.state.lookup.getAllLoanStatus;
    },
    getAllTermsType() {
      return this.$store.getters["lookup/termsTypeLookupByPaymentMode"](
        this.getEmployeeSalaryByUserId.paymentModeId
      );
    },
    getEmployeeSalaryByUserId() {
      return this.$store.state.hrms.employeeSalaryInformation;
    },
    loanCategoryName() {
      return (id) => this.$store.getters["lookup/loanCategoryLookup"](id);
    },
    loanSubCategoryName() {
      return (id) => this.$store.getters["lookup/loanSubCategoryLookup"](id);
    },
    loanStatusName() {
      return (id) => this.$store.getters["lookup/loanStatusLookup"](id);
    },
    periodName() {
      return (id) => this.$store.getters["lookup/periodLookup"](id);
    },
    termsTypeName() {
      return (id) => this.$store.getters["lookup/termsTypeLookup"](id);
    },
    validForm() {
      this.loanCategory != null &&
        this.loanSubCategory != null &&
        this.loanDate != null &&
        this.principalAmount != "" &&
        this.withInterest != "" &&
        this.amortizationAmount != "" &&
        this.period != null;
    },
    getDateDiff() {
      return (createdOn) => {
        var oneDay = 1;
        if (createdOn !== null && this.currentDate !== null) {
          var date1 = new Date(moment(createdOn).format("MM-DD-YYYY"));
          var date2 = new Date(moment(this.currentDate).format("MM-DD-YYYY"));

          var timeDiff = Math.abs(date2.getTime() - date1.getTime());
          var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
          if (diffDays !== "NaN") {
            return diffDays + oneDay;
          } else {
            return 0;
          }
        }
      };
    },
    sortedLoans() {
      console.log("Computed: sortedLoans called");

      if (this.sortKey) {
        const sortedData = this.getAllLoans.slice().sort((a, b) => {
          let aValue = a[this.sortKey];
          let bValue = b[this.sortKey];

          if (aValue == null) return this.sortOrder;
          if (bValue == null) return -this.sortOrder;

          if (typeof aValue === "number" && typeof bValue === "number") {
            return this.sortOrder * (aValue - bValue);
          }
          return this.sortOrder * aValue.localeCompare(bValue);
        });

        console.log("Sorted Data:", sortedData);
        return sortedData;
      } else {
        return this.getAllLoans;
      }
    },
  },
  watch: {
    // principalAmount() {
    //      this.withInterest = parseFloat(this.principalAmount) + (parseFloat(this.principalAmount) * ((parseFloat(this.interestRate) / 100) * parseInt(this.noOfTerms)))
    //       this.amortizationAmount = parseFloat(this.withInterest) / parseInt(this.noOfTerms)
    //      this.amortizationAmount = this.amortizationAmount.toFixed(2)
    // },
    // interestRate() {
    //     //  this.interestRate = parseFloat(this.interestRate )
    //      this.withInterest = parseFloat(this.principalAmount) + (parseFloat(this.principalAmount) * ((parseFloat(this.interestRate) / 100) * parseInt(this.noOfTerms)))
    //       this.amortizationAmount = parseFloat(this.withInterest) / parseInt(this.noOfTerms)
    //      this.amortizationAmount = this.amortizationAmount.toFixed(2)
    // },
    // noOfTerms() {
    //      this.withInterest = parseFloat(this.principalAmount) + (parseFloat(this.principalAmount) * ((parseFloat(this.interestRate) / 100) * parseInt(this.noOfTerms)))
    //      this.amortizationAmount = parseFloat(this.withInterest) / parseInt(this.noOfTerms)
    //      this.amortizationAmount = this.amortizationAmount.toFixed(2)
    // }
  },
  methods: {
    promptAddNewLoans() {
      this.activePromptAddRecord = true;
    },
    editRecord(id) {
      const e = this.$store.getters["payroll/getLoansById"](id);
      (this.loanCategory = this.loanCategoryName(e.loanCategoryId)),
        (this.loanSubCategory = this.loanSubCategoryName(e.loanSubCategoryId));
      (this.referenceNumber = e.referenceNumber),
        (this.loanDate = e.loanDate),
        (this.principalAmount = e.principalAmount),
        (this.interestRate = e.interestRate),
        (this.withInterest = e.withInterest),
        (this.amortizationAmount = e.amortizationAmount),
        (this.beginningBalance = e.beginningBalance),
        (this.period = this.periodName(e.periodId)),
        (this.loanStatus = this.loanStatusName(e.loanStatus));
      (this.isHold = e.isHold),
        (this.resumeDate = e.isHold ? this.resumeDate : null),
        (this.effectivityDate = e.effectivityDate),
        (this.expirationDate = e.expirationDate),
        (this.isActive = e.isActive),
        (this.dateDeactivated = e.dateDeactivated),
        (this.dateReActivated = e.dateReActivated),
        (this.userId = e.userId);
      this.loansId = e.id;
      this.activePromptEditRecord = true;
    },
    confirmDeleteRecord(id) {
      this.$vs.loading();
      this.$store
        .dispatch("payroll/DeleteEmployeeLoans", id)
        .then((res) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: "Loans Deleted",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status == 400) {
            this.$vs.notify({
              title: "Information",
              text: "Cannot be deleted. The item is in used",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
            });
          } else {
            this.$vs.notify({
              title: "Error",
              text: "test",
              iconPack: "feather",
              icon: "icon-x-octagon",
              color: "danger",
            });
          }
        });
    },
    onAddRecord() {
      const e = {
        loanCategoryId: this.loanCategory.loanCategoryId,
        loanSubCategoryId: this.loanSubCategory.loanSubCategoryId,
        referenceNumber: this.referenceNumber, //this.loanCategory.loanCategoryName.charAt(0) + moment(this.loanDate).format('YYYYMMDD') +  this.loanSubCategory.loanSubCategoryCode.toUpperCase() + moment(this.loanDate).format('hhmmss'),
        loanDate: this.loanDate,
        termsTypeId:
          this.period.periodId == 2
            ? 4
            : this.period.periodId == 3 || this.period.periodId == 4
            ? 4
            : this.period.periodId == 5
            ? 3
            : 2,
        loanTerms: this.noOfTerms,
        principalAmount: this.principalAmount,
        interestRate: this.interestRate,
        withInterest: this.withInterest,
        beginningBalance: this.beginningBalance,
        amortizationAmount: this.amortizationAmount,
        periodId: this.period.periodId,
        loanStatus: 1,
        isHold: this.isHold,
        resumeDate: this.isHold ? this.resumeDate : null,
        effectivityDate: this.effectivityDate,
        expirationDate: this.expirationDate,
        isActive: this.isActive,
        dateDeactivated: this.dateDeactivated,
        dateReActivated: this.dateReActivated,
        userId: this.userId,
        currentUserId: this.$store.state.AppActiveUser.uid,
      };
      this.$store.dispatch("payroll/AddEmployeeLoans", e).then((res) => {
        this.$vs.loading.close();
      });
    },
    onUpdateRecord() {
      const e = {
        loanCategoryId: this.loanCategory.loanCategoryId,
        loanSubCategoryId: this.loanSubCategory.loanSubCategoryId,
        referenceNumber: this.referenceNumber,
        loanDate: this.loanDate,
        termsTypeId: this.termsType.value,
        loanTerms: this.noOfTerms,
        principalAmount: this.principalAmount,
        interestRate: this.interestRate,
        withInterest: this.withInterest,
        beginningBalance: this.beginningBalance,
        amortizationAmount: this.amortizationAmount,
        periodId: this.period.periodId,
        loanStatus: this.loanStatus.value,
        isHold: this.isHold,
        resumeDate: this.isHold ? this.resumeDate : null,
        effectivityDate: this.effectivityDate,
        expirationDate: this.expirationDate,
        isActive: this.isActive,
        dateDeactivated: this.dateDeactivated,
        dateReActivated: this.dateReActivated,
        userId: this.userId,
        id: this.loansId,
        currentUserId: this.$store.state.AppActiveUser.uid,
      };
      this.$store.dispatch("payroll/UpdateEmployeeLoans", e).then((res) => {
        this.$vs.loading.close();
      });
    },
    sort(key) {
      console.log("Method: sort called with key:", key);

      if (this.sortKey === key) {
        this.sortOrder *= -1;
      } else {
        this.sortKey = key;
        this.sortOrder = 1;
      }

      console.log("Sort Key:", this.sortKey);
      console.log("Sort Order:", this.sortOrder);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
